import TicketsProvider from './TicketsContext';
import Tickets from './Tickets';


let Index = () => {
    return (
        <TicketsProvider>
            
            <Tickets />
        </TicketsProvider>
    )
}

export default Index;